import React, { useState } from "react";
import Logo from "../../../images/logo_uvm.png";
import "./header.css";
import { CircularProgress } from "@material-ui/core";
import { getRequest } from "../../Funciones/requester";
import AvatarIcon from "../../../images/AvatarIcon";
import NewModal from "../NewModal/newModal";
import HelpIcon from "@material-ui/icons/Help";

export default function Header(props) {
  const [modalSesion, setModalSesion] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);

  async function logout() {
    setModalLoading(true);

    let response = await getRequest("/logout");
    if (response.s === "OK") {
      localStorage.removeItem("token_syllabus");
      window.location.reload();
    }
  }

  return (
    <header>
      <div className="logo">
        <img src={Logo} alt="Logo UVM" />
      </div>
      <div className="page-title">
        <h1>Plataforma de registro de tema syllabus</h1>
      </div>
      <a
        href="https://mexlaureate.service-now.com/mesa_uvm"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          textDecoration: "none",
          color: "inherit",
        }}
      >
        <HelpIcon style={{ width: "50px", height: "50px" }} />
        Ayuda
      </a>
      <div className="user-info">
        <div>
          <p className="user-name">{props.username}</p>
          <p className="user-rol">Profesor</p>
        </div>
        {props.image ? (
          <img src={props.img} alt="avatar" />
        ) : (
          <AvatarIcon onClick={() => setModalSesion(true)} />
        )}
        <NewModal
          title="Cerrar sesión"
          open={modalSesion}
          handleClose={() => setModalSesion(false)}
          handleSubmit={logout}
        >
          <div style={{ height: "80px", textAlign: "center", paddingTop: "20px" }}>
            {modalLoading ? (
              <CircularProgress />
            ) : (
              <p style={{ textAlign: "center" }}>¿Está seguro de que desea cerrar sesión?</p>
            )}
          </div>
        </NewModal>
      </div>
    </header>
  );
}
